(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('roya-stone-preference')) {
    customElements.define('roya-stone-preference', class extends HTMLElement {
      connectedCallback() {
        this.canonicalInput = this.querySelector('[data-roya-preference-canonical]');
        this.onPreferenceChange = () => {
          const selected = this.querySelector('[data-roya-preference-value]:checked');
          if (selected && this.canonicalInput) {
            this.canonicalInput.value = selected.dataset.royaPreferenceValue;
          }
        };
        this.addEventListener('change', this.onPreferenceChange);
        this.onPreferenceChange();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onPreferenceChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
